module.exports = __webpack_public_path__ + "img/xiaolanling_logo.a3bd183c.jpg";